import { FilterGroup } from 'components/Filters/components/FilterModal'
import { SelectFilter } from 'components/Filters/fields/SelectFilter'
import { RangeFilter } from 'components/Filters/fields/RangeFilter'
import { createFilterColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import type { WorkflowStatus } from 'models/campaign'
import {
  SEQUENCE_COLUMNS,
  sequenceStatusFilterOptions,
} from './sequenceColumnInfo'

interface Props {
  filterStore: ReturnType<any>
  /** Drives which Sequence Status options are offered — matches the chips. */
  campaignWorkflowStatus?: WorkflowStatus
}

/**
 * Hook variant that returns the Sequencing-group filter elements as a
 * Fragment (no FilterGroup wrapper). Use this in sortable filtersets so
 * FilterModal's alphabetical walker can see each filter as a direct
 * React.Children entry and bucket it by first letter.
 */
export function useSequenceFilters({
  filterStore,
  campaignWorkflowStatus,
}: Props) {
  const filterHelper = createFilterColumnHelper({
    columns: SEQUENCE_COLUMNS,
  })

  return (
    <>
      <SelectFilter
        {...filterHelper.retrieveProps('seq_sequence_step')}
        filterKey="sequence_progress"
        title="Sequence Status"
        options={sequenceStatusFilterOptions(campaignWorkflowStatus)}
        filterStore={filterStore}
      />
      <RangeFilter
        title="Scheduled Emails"
        filterKey="seq_scheduled_emails"
        store={filterStore}
      />
      <RangeFilter
        title="Replies"
        filterKey="seq_replies"
        store={filterStore}
      />
    </>
  )
}

export function SequenceFilterGroup(props: Props) {
  const filters = useSequenceFilters(props)
  return (
    <FilterGroup title="Sequencing" className="lg:grid-cols-2">
      {filters}
    </FilterGroup>
  )
}
